import styled from "styled-components";

export const StyledSectionContainerDiv = styled.div`
  flex: 1;
  font-family: Inter;
  padding: 32px 136px 8px;

  border-top: 1px solid var(--Color-Tokens-Border-Primary, #e4e4e4);
  border-bottom: 1px solid var(--Color-Tokens-Border-Primary, #e4e4e4);
  background: var(--CLOUD, #fcfdfe);

  display: flex;
  flex-direction: column;
`;

export const StyledHeaderContainerDiv = styled.div`
  color: #0e0e2c;
  font-family: Inter;
  font-style: normal;
  line-height: 120%; /* 24px */

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StyledHeaderDiv = styled.div`
  font-size: 20px;
  font-weight: 600;
`;

export const StyledDescriptionDiv = styled.div`
  font-size: 14px;
  font-weight: 400;
`;
